import React from 'react';
import { useNavigate } from 'react-router-dom';
 
const INDIVIDUAL_PLANS = [
  {
    name: 'Starter',
    price: '$49',
    priceId: 'price_1TPq18Kvsr6YPyDcPE62Vb3C',
    features: ['Script step navigation', 'Script library', 'Objection library', 'One-tap objection responses'],
    color: '#4ade80',
    dim: 'rgba(74,222,128,0.1)',
    border: 'rgba(74,222,128,0.25)',
  },
  {
    name: 'Pro',
    price: '$99',
    priceId: 'price_1TPqHbKvsr6YPyDcxNeJq7iy',
    features: ['Everything in Starter', 'Live mic — unlimited', 'Auto-detects objections', 'AI assist for unknown objections', 'EN/ES language toggle'],
    color: '#60a5fa',
    dim: 'rgba(96,165,250,0.1)',
    border: 'rgba(96,165,250,0.25)',
    popular: true,
  },
  {
    name: 'Elite',
    price: '$149',
    priceId: 'price_1TPqIZKvsr6YPyDc3qERJVaz',
    features: ['Everything in Pro', 'Early access to new features', 'Call analytics (coming soon)', 'Call history (coming soon)'],
    color: '#a78bfa',
    dim: 'rgba(167,139,250,0.1)',
    border: 'rgba(167,139,250,0.25)',
  },
];
 
const AGENCY_PLANS = [
  {
    name: 'Agency Starter',
    price: '$199',
    features: ['Up to 5 agents', 'All Starter features per agent', 'Saves vs 5 individual plans'],
    color: '#fb923c',
    dim: 'rgba(251,146,60,0.1)',
    border: 'rgba(251,146,60,0.25)',
  },
  {
    name: 'Agency Pro',
    price: '$599',
    features: ['Up to 10 agents', 'All Pro features per agent', 'Saves vs 10 individual plans'],
    color: '#f472b6',
    dim: 'rgba(244,114,182,0.1)',
    border: 'rgba(244,114,182,0.25)',
  },
  {
    name: 'Agency Elite',
    price: '$1,499',
    features: ['Up to 20 agents', 'All Elite features per agent', 'Advanced dashboard (coming soon)', 'Manager insights (coming soon)'],
    color: '#fbbf24',
    dim: 'rgba(251,191,36,0.1)',
    border: 'rgba(251,191,36,0.25)',
  },
];
 
function PlanCard({ plan, onSelect }) {
  return (
    <div style={{
      background: '#111113',
      border: `0.5px solid ${plan.popular ? plan.border : 'rgba(255,255,255,0.07)'}`,
      borderRadius: '12px',
      padding: '20px',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    }}>
      {plan.popular && (
        <div style={{ position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)', background: plan.dim, border: `0.5px solid ${plan.border}`, borderRadius: '99px', padding: '2px 12px', fontSize: '10px', fontWeight: '500', color: plan.color, whiteSpace: 'nowrap' }}>
          Most popular
        </div>
      )}
      <div style={{ marginBottom: '12px' }}>
        <p style={{ fontSize: '13px', fontWeight: '500', color: plan.color, marginBottom: '6px' }}>{plan.name}</p>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '2px' }}>
          <span style={{ fontSize: '26px', fontWeight: '600', color: '#f0efe8' }}>{plan.price}</span>
          <span style={{ fontSize: '12px', color: '#888880' }}>/month</span>
        </div>
      </div>
      <div style={{ flex: 1, marginBottom: '16px' }}>
        {plan.features.map((f, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: '0.5px solid rgba(255,255,255,0.05)' }}>
            <span style={{ color: plan.color, fontSize: '11px', flexShrink: 0 }}>✓</span>
            <span style={{ fontSize: '12px', color: '#888880' }}>{f}</span>
          </div>
        ))}
      </div>
      {plan.priceId ? (
        <button onClick={onSelect} style={{
          width: '100%', padding: '10px', fontSize: '13px', fontWeight: '500',
          borderRadius: '6px', cursor: 'pointer',
          background: plan.dim, border: `0.5px solid ${plan.border}`, color: plan.color,
          fontFamily: "'DM Sans', sans-serif"
        }}>
          Start free trial →
        </button>
      ) : (
        <button onClick={onSelect} style={{
          width: '100%', padding: '10px', fontSize: '13px', fontWeight: '500',
          borderRadius: '6px', cursor: 'pointer',
          background: plan.dim, border: `0.5px solid ${plan.border}`, color: plan.color,
          fontFamily: "'DM Sans', sans-serif"
        }}>
          Contact us →
        </button>
      )}
    </div>
  );
}
 
export default function PublicPricing() {
  const navigate = useNavigate();
 
  React.useEffect(() => { window.scrollTo(0, 0); }, []);
 
  const handleSelect = () => {
    navigate('/login');
  };
 
  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0b', fontFamily: "'DM Sans', sans-serif", color: '#f0efe8' }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&family=Fraunces:ital,wght@0,300;0,600;1,300&display=swap" rel="stylesheet" />
 
      {/* Nav */}
      <nav style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '0.5px solid rgba(255,255,255,0.06)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }} onClick={() => navigate('/')}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 8px #4ade80' }}></div>
          <span style={{ fontSize: '15px', fontWeight: '600' }}>ObjectionReady</span>
        </div>
        <button onClick={() => navigate('/login')} style={{ fontSize: '13px', fontWeight: '500', color: '#0a0a0b', background: '#4ade80', border: 'none', borderRadius: '6px', padding: '8px 16px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>
          Start free trial
        </button>
      </nav>
 
      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '60px 24px 80px' }}>
 
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <h1 style={{ fontSize: 'clamp(32px, 6vw, 52px)', fontWeight: '300', letterSpacing: '-.03em', fontFamily: "'Fraunces', serif", marginBottom: '12px' }}>
            Simple, honest pricing
          </h1>
          <p style={{ fontSize: '16px', color: '#888880' }}>3-day free trial on all plans · Cancel anytime</p>
        </div>
 
        {/* Individual */}
        <div style={{ marginBottom: '48px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#555550', textTransform: 'uppercase', letterSpacing: '.08em', fontFamily: "'DM Mono', monospace" }}>Individual</span>
            <div style={{ flex: 1, height: '0.5px', background: 'rgba(255,255,255,0.07)' }}></div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch' }}>
            {INDIVIDUAL_PLANS.map(plan => (
              <PlanCard key={plan.name} plan={plan} onSelect={handleSelect} />
            ))}
          </div>
        </div>
 
        {/* Agency */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#555550', textTransform: 'uppercase', letterSpacing: '.08em', fontFamily: "'DM Mono', monospace" }}>Agency</span>
            <div style={{ flex: 1, height: '0.5px', background: 'rgba(255,255,255,0.07)' }}></div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch' }}>
            {AGENCY_PLANS.map(plan => (
              <PlanCard key={plan.name} plan={plan} onSelect={handleSelect} />
            ))}
          </div>
        </div>
 
        {/* FAQ */}
        <div style={{ marginTop: '64px', maxWidth: '640px', margin: '64px auto 0' }}>
          <h2 style={{ fontSize: '22px', fontWeight: '300', fontFamily: "'Fraunces', serif", marginBottom: '24px', textAlign: 'center' }}>Questions</h2>
          {[
            { q: 'Do I need a credit card for the trial?', a: 'Yes — we require a card to start your trial but you won\'t be charged until day 4. Cancel anytime before then.' },
            { q: 'Can I switch plans?', a: 'Yes — upgrade or downgrade anytime from your account settings. Changes take effect immediately.' },
            { q: 'What happens after the trial?', a: 'You\'ll be automatically charged for the plan you selected. You\'ll get an email reminder before the trial ends.' },
            { q: 'Do agency plans share one login?', a: 'Each agent gets their own login. Agency plans give you a set number of seats at a discounted rate.' },
          ].map((faq, i) => (
            <div key={i} style={{ borderBottom: '0.5px solid rgba(255,255,255,0.07)', padding: '16px 0' }}>
              <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '6px' }}>{faq.q}</p>
              <p style={{ fontSize: '13px', color: '#888880', lineHeight: '1.6', margin: 0 }}>{faq.a}</p>
            </div>
          ))}
        </div>
 
      </div>
    </div>
  );
}